module.exports = __webpack_public_path__ + "img/AC8961_EBDAC3_D1B791_DCC2A0-256px.9a9716d1.png";